import { OrgLastChangedBy } from '../../org-dashboard/models/org-widget.models';

/** The bits of the signed-in Firebase user we need (a structural subset, so specs can pass a literal). */
export interface ChangeActor {
    uid?: string | null;
    displayName?: string | null;
    email?: string | null;
}

/** `{ uid, name }` for the acting user, or null when nobody is signed in. */
export function lastChangedByOf(user: ChangeActor | null | undefined): OrgLastChangedBy | null {
    if (!user?.uid) return null;
    return { uid: user.uid, name: (user.displayName || user.email || '').trim() };
}

/**
 * Record who changed an org entity (hat, security group, policy, feature) as `lastChangedBy`.
 * The org-doc cache mirrors the whole subcollection doc, so the field reaches the dashboard's
 * Recent Activity without any backend change. Mutates and returns the payload, like `stampBlame`.
 */
export function stampLastChangedBy<T extends Record<string, any>>(payload: T, user: ChangeActor | null | undefined): T {
    const by = lastChangedByOf(user);
    if (by) (payload as Record<string, any>)['lastChangedBy'] = by;
    return payload;
}
